module.exports = __webpack_public_path__ + "assets/img/busy_12.573251e4.png";